const axios = require('axios');


/**
 * Update or create item (product table)
 * Item can be table, category or menu depending on type variable
 * @param product
 */
export function updateProductItem(product) {
  return new Promise(function (resolve, reject) {
    console.log("updateProductItem ")
    axios.post(process.env.ROOT_API + 'product', JSON.stringify(product), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Product Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        reject()
      });
  })
}

/**
 * Update or create item (category table)
 * Item can be table, category or menu depending on type variable
 * @param product
 */
export function updateCategoryItem(category) {
  return new Promise(function (resolve, reject) {
    console.log("updateCategoryItem ")
    axios.post(process.env.ROOT_API + 'category', JSON.stringify(category), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Category Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        //reject()
      });
  })
}
export function updateProductItems(products) {
  return new Promise(function (resolve, reject) {
    console.log("updateCategoryItem ")
    axios.post(process.env.ROOT_API + 'products', JSON.stringify(products), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Product Items update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        reject()
      });
  })
}

export function updateCategoryItems(categories) {
  return new Promise(function (resolve, reject) {
    console.log("updateCategoryItem ")
    axios.post(process.env.ROOT_API + 'categories', JSON.stringify(categories), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Category Items update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        reject()
      });
  })
}
export function getCategoryById(cid) {
  return new Promise(function (resolve, reject) {
    console.log("getMerchant Menus ")
    axios.get(process.env.ROOT_API + 'category/' + cid, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        //reject()
      });
  })
}


export function getProductById(id) {
  return new Promise(function (resolve, reject) {
    console.log("getProductById " + id)
    axios.get(process.env.ROOT_API + 'product/' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        //reject()
      });
  })
}

export function getProductWithBarcode(barcode) {
  return new Promise(function(resolve, reject){
    console.log("getProductWithBarcode " + barcode, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    });
    axios.get(process.env.ROOT_API + 'product/barcode/' + barcode, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        console.log("getProductWithBarcode response ok");
        let data = response.data;
        console.log(data);
        resolve(data);
      })
      .catch(function(err){
        reject(err);
      })
  })
}
/**
 * Get products of category
 * @param id
 * @returns {Promise<unknown>}
 */
export function getProductsByCategory(cid) {
  return new Promise(function (resolve, reject) {
    console.log("getProductsByCategory " + cid)
    axios.get(process.env.ROOT_API + 'category/' + cid + '/products', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        //reject()
      });
  })
}

/**
 * Get categories
 * @param id
 * @returns {Promise<unknown>}
 */
export function getCategories() {
  return new Promise(function (resolve, reject) {
    console.log("getCategories")

    // let data = {
    //   success:true,
    //   item:[
    //     {
    //       title:"Cat A",
    //       pos: 0,
    //     },
    //     {
    //       title:"Cat B",
    //       pos: 1,
    //     },
    //     {
    //       title:"Cat C",
    //       pos: 2,
    //     },
    //   ]
    // }
    // resolve(data);
    axios.get(process.env.ROOT_API + 'categories', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        //reject()
      });
  })
}

export function getProductStock(pid, from ,to) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStock " + pid);

    axios.get(process.env.ROOT_API + 'product/' + pid + '/stock/' + from  + '/' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        console.log(err);
        console.log(err.response);
        reject(err);
      })
  })
}
export function getCategoryStock(cid, from, to) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStock " + pid);
    axios.get(process.env.ROOT_API + 'category/' + cid + '/stock/' + from  + '/' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}

// export function addStock(stock) {
//   return new Promise(function(resolve, reject){
//     axios.post(process.env.ROOT_API + 'stock', JSON.stringify(stock), {
//       headers: {
//         "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
//         "Content-Type": "application/json"
//       }
//     }).then(function(response){
//       let data = response.data;
//       resolve(data);
//     }).catch(function(err){
//       reject(err);
//     })
//
//   })
// }

export function addStock(stock) {
  return new Promise(function(resolve, reject){
    axios.post(process.env.ROOT_API + 'stock', JSON.stringify(stock), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response){
      let data = response.data;
      resolve(data);
    }).catch(function(err){
      reject(err);
    })

  })
}

export function deleteStock(sId) {
  return new Promise(function(resolve, reject){
    axios.get(process.env.ROOT_API + 'stock/delete?id='+sId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response){
      let data = response.data;
      resolve(data);
    }).catch(function(err){
      reject(err);
    })

  })
}

export function getStockListWithTime(from, to) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStock from: " + from + " to " + to);
    axios.get(process.env.ROOT_API + 'stocks/time/' + from  + '/' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}
export function getStockListWithInvoiceNumber(invoiceNumber) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStock invoiceNumber: " + invoiceNumber);
    axios.get(process.env.ROOT_API + 'stocks/invoice/' + invoiceNumber, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}

export function updateProductStock(pid) {
  return new Promise(function(resolve, reject) {
    console.log("updateProductStock " + pid);
    axios.get(process.env.ROOT_API + 'product/' + pid + '/updateStock', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}

/**
 * Get Stock of product by state
 * @param pid
 * @param state
 * @returns {Promise<unknown>}
 */
export function getProductStockListByState(pid, state) {
  return new Promise(function(resolve, reject) {
    console.log("updateProductStock " + pid);
    axios.get(process.env.ROOT_API + 'stocks?productId=' + pid + '&state=' + state, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}

export function getLowStockProduct() {
  return new Promise(function(resolve, reject) {
    console.log("getLowStockProduct ");
    axios.get(process.env.ROOT_API + 'product/lowstocks', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        console.log("GetLowstock Error " + err);
        if(err.response != undefined) {
          console.log(err.response);
        }

        reject(err);
      })
  })
}
export function getProductStockListByStateRange(pid, stateFrom, stateTo) {
  return new Promise(function(resolve, reject) {
    console.log("updateProductStock " + pid);
    axios.get(process.env.ROOT_API + 'stocks?productId=' + pid + '&stateFrom=' + stateForm + '&stateTo=' + stateTo, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}

export function getProductStockListByStateAndTimeRange(pid, state, from, to) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStockListByStateAndTimeRange " + pid);
    axios.get(process.env.ROOT_API + 'stocks?productId=' + pid + '&state=' + state + '&from=' + from + '&to=' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}
export function getProductSoldStockListByStateAndTimeRange(pid, state, from, to) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStockListByStateAndTimeRange " + pid);
    axios.get(process.env.ROOT_API + 'stocks/sold/state/time?productId=' + pid + '&state=' + state + '&from=' + from + '&to=' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}
export function getProductInStockListByStateAndTimeRange(pid, state, from, to) {
  return new Promise(function(resolve, reject) {
    console.log("getProductStockListByStateAndTimeRange " + pid);
    axios.get(process.env.ROOT_API + 'stocks/in/state/time?productId=' + pid + '&state=' + state + '&from=' + from + '&to=' + to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}


export function deleteProduct(pid) {
  return new Promise(function(resolve, reject) {
    console.log("deleteProduct " + pid);
    axios.get(process.env.ROOT_API + 'product/delete?id=' + pid, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}

export function deleteCategory(cid) {
  return new Promise(function(resolve, reject) {
    console.log("deleteCategory " + cid);
    axios.get(process.env.ROOT_API + 'category/delete?id=' + cid, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js